/*
 * @FilePath: /daren-html-source/src/utils/apiList/user.js
 * @Description: 
 */
import request from "../api/request";
import utils from "../../utils/index";
import pfile from "@/utils/secretkey/pfile";
import sfile from "@/utils/secretkey/sfile";
var ak = utils.genak();
var ed = utils.re(ak, unescape(pfile)); //秘钥
function decrypt(data) {
    if (data?.ak) {
        let plaintext = utils.rd(data.ak, unescape(sfile));
        let obj = utils.secret(data.ed, plaintext, true);
        return JSON.parse(obj);
    } else {
        return data;
    }
}
function inParameter(data) {
    if (data) {
        return { sn: ed, jt: utils.secret(data, ak) };
    } else {
        return data;
    }
}

//发送邮箱验证码
export function sendEmailModifyAPI(data) {
    return request({
        url: "/user-service/user/sendEmailModify",
        method: "post",
        data: inParameter(data),
    }).then((res) => {
        res.data = decrypt(res.data);
        return res;
    })
        .catch((err) => {
            console.log(err);
        });
}
//绑定邮箱
export function bindEmailAPI(data) {
    return request({
        url: "/user-service/user/bindEmail",
        method: "post",
        data: inParameter(data),
    }).then((res) => {
        res.data = decrypt(res.data);
        return res;
    })
        .catch((err) => {
            console.log(err);
        });
}
export function beingEmailCodeCheckAPI(data) {
    return request({
        url: "/user-service/user/beingEmailCodeCheck",
        method: "post",
        data: inParameter(data),
    })
        .then((res) => {
            res.data = decrypt(res.data);
            return res;
        })
        .catch((err) => {
            console.log(err);
        });
}

